import { useEffect, useRef, useState } from "react";

const values = [
  {
    icon: "ri-shield-check-line",
    title: "Sertifikalı Çözümler",
    desc: "Her ortağımız kendi alanında üretici sertifikalarına sahiptir. Sunduğumuz tüm donanım ve yazılım çözümleri orijinal ve garanti kapsamındadır.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Hızlı Teslimat",
    desc: "Üreticilerle doğrudan iş ortaklığımız, öncelikli tedarik ve hızlı kurulum imkânı sağlar. Projeleriniz zamanında devreye alınır.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Ölçeklenebilir Altyapı",
    desc: "Tüm çözümlerimiz birkaç kullanıcıdan binlerce uç noktaya kadar ölçeklenebilir. Büyümenizle birlikte altyapınız da büyür.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Kesintisiz Destek",
    desc: "Üretici destek hatlarına doğrudan erişim ve 7/24 yönetilen hizmetlerle sistemleriniz her zaman ayakta ve güncel kalır.",
  },
];

export default function WhyPartners() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#F1F5F9] py-20 border-t border-[#E2E8F0]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-[#3B82F6]"></div>
              <span className="text-[#334155] text-xs font-semibold tracking-[0.3em] uppercase">Ortaklık Felsefesi</span>
            </div>
            <h2
              className="text-[#0F172A] font-black uppercase leading-tight"
              style={{ fontSize: "clamp(24px, 3vw, 44px)", letterSpacing: "-0.02em" }}
            >
              Neden Uzun Vadeli<br />
              <span className="text-[#64748B]">Stratejik Ortaklık?</span>
            </h2>
          </div>
          <p className="text-[#64748B] text-sm leading-relaxed max-w-sm md:text-right">
            C2TEK, tek seferlik tedarikçilik yerine derinlikli ve uzun vadeli teknoloji ortaklığı modelini benimsemektedir.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {values.map((v, i) => (
            <div
              key={i}
              className={`bg-[#FFFFFF] border border-[#E2E8F0] p-7 flex flex-col gap-4 hover:border-[#3B82F6] transition-all duration-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center border border-[#E2E8F0] bg-[#F1F5F9]">
                <i className={`${v.icon} text-[#3B82F6] text-lg`}></i>
              </div>
              <h3 className="text-[#0F172A] font-bold text-sm">{v.title}</h3>
              <p className="text-[#64748B] text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
